/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type CreateFeePlanAgreement = {
  planID: string;
};

/** @internal */
export const CreateFeePlanAgreement$inboundSchema: z.ZodType<
  CreateFeePlanAgreement,
  z.ZodTypeDef,
  unknown
> = z.object({
  planID: z.string(),
});
/** @internal */
export type CreateFeePlanAgreement$Outbound = {
  planID: string;
};

/** @internal */
export const CreateFeePlanAgreement$outboundSchema: z.ZodType<
  CreateFeePlanAgreement$Outbound,
  z.ZodTypeDef,
  CreateFeePlanAgreement
> = z.object({
  planID: z.string(),
});

export function createFeePlanAgreementToJSON(
  createFeePlanAgreement: CreateFeePlanAgreement,
): string {
  return JSON.stringify(
    CreateFeePlanAgreement$outboundSchema.parse(createFeePlanAgreement),
  );
}
export function createFeePlanAgreementFromJSON(
  jsonString: string,
): SafeParseResult<CreateFeePlanAgreement, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CreateFeePlanAgreement$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreateFeePlanAgreement' from JSON`,
  );
}
